function trimTrailingSlashes(value) {
  return String(value || "").trim().replace(/\/+$/g, "");
}

export function configuredReviewPackagerUrl() {
  const runtimeUrl = (
    typeof window !== "undefined" &&
    (window.__REVIEW_PACKAGER_URL || localStorage.getItem("reviewPackagerURL"))
  ) || "";
  const envUrl = typeof process !== "undefined"
    ? process.env.REACT_APP_REVIEW_PACKAGER_URL || process.env.VITE_REVIEW_PACKAGER_URL
    : "";
  return trimTrailingSlashes(runtimeUrl || envUrl);
}

export function configuredReviewPackagerAuthToken() {
  const runtimeToken = (
    typeof window !== "undefined" &&
    (window.__REVIEW_PACKAGER_AUTH_TOKEN || localStorage.getItem("reviewPackagerAuthToken"))
  ) || "";
  const envToken = typeof process !== "undefined"
    ? process.env.REACT_APP_REVIEW_PACKAGER_AUTH_TOKEN || process.env.VITE_REVIEW_PACKAGER_AUTH_TOKEN
    : "";
  return String(runtimeToken || envToken || "").trim();
}

export function reviewPackagerRequestHeaders() {
  const token = configuredReviewPackagerAuthToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export function codeArchitectureReviewPackagingTarget(backendUrl) {
  const hostedPackagerUrl = configuredReviewPackagerUrl();
  if (hostedPackagerUrl) {
    return { mode: "hosted", url: hostedPackagerUrl };
  }

  const value = trimTrailingSlashes(backendUrl);
  if (!value || value.includes("execute-api")) {
    return { mode: "local", url: "http://localhost:5001" };
  }
  return { mode: "local", url: value };
}

export function isHostedCodeArchitectureReviewPackagerConfigured() {
  return codeArchitectureReviewPackagingTarget().mode === "hosted";
}

export function codeArchitectureReviewPackageStartBody({
  reviewPackage,
  reviewAppTarget = "mac",
  destinationDirectory = "",
  packagingMode = "local",
} = {}) {
  return {
    reviewPackage,
    reviewAppTarget,
    ...(packagingMode === "local" ? { destinationDirectory } : {}),
  };
}
